import {
  AfterContentInit,
  Component,
  ContentChild,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { LayoutMainDirective } from '../layout-center.directive';
import { LayoutLeftDirective } from '../layout-left.directive';
import { LayoutRightDirective } from '../layout-right.directive';

@Component({
  selector: 'am-layout-cols',
  templateUrl: './layout-cols.component.html',
  styleUrls: ['./layout-cols.component.scss'],
})
export class LayoutColsComponent implements AfterContentInit {
  @ContentChildren(LayoutLeftDirective, { descendants: false })
  leftEls: QueryList<LayoutLeftDirective>;
  @ContentChildren(LayoutMainDirective, { descendants: false })
  mainEls: QueryList<LayoutMainDirective>;
  @ContentChildren(LayoutRightDirective, { descendants: false })
  rightEls: QueryList<LayoutRightDirective>;

  leftEl: LayoutLeftDirective;
  mainEl: LayoutMainDirective;
  rightEl: LayoutRightDirective;

  public get gridTemplateColumns(): string {
    const gtr = {
      left: this.leftEl ? this.leftEl.width : '0',
      center: '1fr',
      right: this.rightEl ? this.rightEl.width : '0',
    };
    return Object.values(gtr).join(' ');
  }

  ngAfterContentInit() {
    this.leftEl = this.leftEls.toArray()[0];
    this.mainEl = this.mainEls.toArray()[0];
    this.rightEl = this.rightEls.toArray()[0];
  }
}
